var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message != '')?_c('div',{staticClass:"px-3 py-2 border radius-0 text-center d-block mb-3",staticStyle:{"background-color":"rgb(255, 210, 195)","border-color":"rgb(247, 111, 111) !important"}},[_c('p',{staticClass:"mb-0 body-2-1 w-75 mx-auto"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a65a0fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hotel/concierge/general/ErrorMessage.vue
// module id = null
// module chunks = 